import { demoStore } from './demoStore';
import { IS_DEMO } from './demoMode';

/** פס קבוע בראש כל מסך במצב תצוגה — כדי שאף אחד לא יחשוב שאלה נתונים אמיתיים. */
export function DemoBanner() {
  if (!IS_DEMO) return null;
  return (
    <div role="note" className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-accent px-4 py-1.5 text-center text-[13px] font-semibold text-white">
      <span>מצב תצוגה — נתוני דוגמה בלבד, לא מחובר ל-Firebase</span>
      <button
        type="button"
        onClick={() => {
          if (window.confirm('להחזיר את כל נתוני הדוגמה למצב ההתחלתי?')) demoStore.reset();
        }}
        className="rounded-[6px] bg-white/15 px-2 py-0.5 text-[12px] font-semibold hover:bg-white/25"
      >
        איפוס
      </button>
    </div>
  );
}
